// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar[data-v-ce8d91ee] {\n  min-width: 2rem;\n}\n.chipHeight[data-v-ce8d91ee] {\n  height: 24px;\n}\n.chipCircleWidth[data-v-ce8d91ee] {\n  width: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
